<template>
  <div id="v-login">
    <div v-if="isLoggedIn">
      <img src="../assets/logo.png" height="210px"/><br>
      <h1 class="h-thin">Logged In</h1>
      You are logged in as {{$store.getters.user.email}}. <a @click="submitLogout()">Log out</a>
      <div class="ipt-submit" @click="submitLogout()" v-bind:class="{loading: isLoading}">
        <i class="ipt-icon material-icons">exit_to_app</i>
      </div>
    </div>
    <div v-if="!isCreating && !isLoggedIn">
      <img src="../assets/logo.png" height="210px"/><br>
      <h1 class="h-thin">Login</h1>
      <!--<div style="color: #5B5B5B">Need to create an account? <a @click="switchForm()" class="noafter">Click here.</a></div>-->
      <br>
      <div class="ipt-container">
        <i class="ipt-icon material-icons">email</i>
        <input type="text" placeholder="Email Address" v-model="userEmail"/>
      </div>
      <div class="ipt-container">
        <i class="ipt-icon text-icons">*</i>
        <input type="password" placeholder="Password" v-model="userPassword"/>
      </div>
      <div v-if="error" style="margin: 10px 0; font-size: 0.8em; color: #700000">{{error}}</div>
      <br>
      <div class="ipt-submit" @click="submitLogin()" v-bind:class="{loading: isLoading}">
        <i class="ipt-icon material-icons">chevron_right</i>
      </div>
    </div>
    <div v-if="isCreating && !isLoggedIn">
      <img src="../assets/logo.png" height="210px"/><br>
      <h1 class="h-thin">Create Account</h1>
      <div style="color: #5B5B5B">Need to login? <a @click="switchForm()" class="noafter">Click here.</a></div>
      <br>
      <div class="ipt-container">
        <i class="ipt-icon material-icons">person</i>
        <input type="text" placeholder="Full Name" v-model="userFullName"/>
      </div>
      <div class="ipt-container">
        <i class="ipt-icon text-icons" style="top: -4px">@</i>
        <input type="text" placeholder="Username" v-model="userHandle"/>
      </div>
      <div class="ipt-container">
        <i class="ipt-icon material-icons">email</i>
        <input type="text" placeholder="Email Address" v-model="userEmail"/>
      </div>
      <div class="ipt-container">
        <i class="ipt-icon text-icons">*</i>
        <input type="password" placeholder="Password" v-model="userPassword"/>
      </div>
      <div v-if="error" style="margin: 10px 0; font-size: 0.8em; color: #700000">{{error}}</div>
      <br>
      <div class="ipt-submit" @click="submitCreation()" v-bind:class="{loading: isLoading}">
        <i class="ipt-icon material-icons">chevron_right</i>
      </div>
    </div>
    <br><br>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      isCreating: false,
      userEmail: '',
      userHandle: '',
      userFullName: '',
      userPassword: '',
      error: '',
      isLoading: false,
      isLoggedIn: false
    }
  },
  created: function () {
    if (this.$store.getters.user) {
      this.isLoggedIn = true
    }
    this.$firebase.auth().onAuthStateChanged((user) => {
      this.isLoading = false
      if (user) {
        if (this.isCreating) {
          // Initialize account
          this.$store.commit('updateContext', {
            handle: this.userHandle,
            fullname: this.userFullName
          })
        }

        this.$router.push({ path: (this.isCreating ? 'onboarding' : 'dashboard') })
        this.isLoggedIn = true
      } else {
        // Signed out user.
        this.isLoggedIn = false
      }
    })
  },
  methods: {
    switchForm: function () {
      if (!this.isLoading) {
        this.isCreating = !this.isCreating
      }
    },
    submitLogin: function () {
      if (this.validateLogin() && !this.isLoading) {
        this.isLoading = true
        this.$firebase.auth().signInWithEmailAndPassword(this.userEmail, this.userPassword).catch((err) => {
          this.isLoading = false
          this.error = err.message
        })
      }
    },
    submitLogout: function () {
      this.isLoading = true
      setTimeout(() => {
        this.$firebase.auth().signOut()
      }, 1000)
    },
    submitCreation: function () {
      if (this.validateCreation() && !this.isLoading) {
        this.isLoading = true
        this.$firebase.auth().createUserWithEmailAndPassword(this.userEmail, this.userPassword).catch((err) => {
          this.isLoading = false
          this.error = err.message
        })
      }
    },
    validateLogin: function () {
      if (!this.userEmail.trim().length) {
        this.error = 'Email is required'
        return false
      }
      if (!this.userPassword.trim().length) {
        this.error = 'Password is required'
        return false
      }
      this.error = ''
      return true
    },
    validateCreation: function () {
      if (this.validateLogin()) {
        if (!this.userFullName.trim().length) {
          this.error = 'Full name is required'
          return false
        }
        if (!this.userHandle.trim().length) {
          this.error = 'A username is required'
          return false
        }
        if (!/^[a-zA-Z0-9]+$/.test(this.userHandle)) {
          this.error = 'A valid username (alphanumeric) is required'
          return false
        }
        this.error = ''
        return true
      } else {
        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LoginPage.vue